export default "__VITE_ASSET__DsLxcUGA__"